import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function TechnologiesPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Technologies Management"
        subtitle="Manage technologies for commercialization"
        contentType="technologies"
        fields={[
          // Basic Information
          { name: 'name', label: 'Technology Name', type: 'text', required: true },
          { name: 'category', label: 'Category', type: 'select', options: ['Processing', 'Cultivation', 'Storage', 'Packaging', 'Pest Management', 'Propagation', 'Other'] },
          { name: 'summary', label: 'Short Summary', type: 'textarea', placeholder: 'Brief description for cards' },
          { name: 'description', label: 'Detailed Description', type: 'richtext', hint: 'Full technology details with formatting' },
          
          // Images - File Upload
          { name: 'image_file', label: 'Technology Image', type: 'file', fileType: 'image', hint: 'Upload technology image (JPG, PNG, WEBP)' },
          { name: 'image_url', label: 'Or Image URL (if not uploading)', type: 'text', placeholder: 'https://example.com/image.jpg' },
          
          // Developer Information
          { name: 'inventors', label: 'Name of Inventor(s)/Developer(s)', type: 'text', placeholder: 'e.g., Dr. A.K. Singh' },
          { name: 'collaborators', label: 'Collaborator(s)', type: 'text' },
          { name: 'maintainer_inventor', label: 'Maintainer Inventor', type: 'text' },
          
          // Year Information
          { name: 'year_of_development', label: 'Year of Development', type: 'text' },
          { name: 'year_of_commercialization', label: 'Year of Commercialization', type: 'text' },
          { name: 'year_of_release', label: 'Year of Release', type: 'text' },
          
          // Registration
          { name: 'ppvfra_registration', label: "PPVFRA Breeder's Right Registration", type: 'text' },
          { name: 'ic_number', label: 'IC Number', type: 'text' },
          
          // Licensing Information
          { name: 'nature_of_license', label: 'Nature of License', type: 'select', options: ['Non-Exclusive', 'Exclusive', 'Open'] },
          { name: 'duration', label: 'Duration', type: 'text' },
          { name: 'licensing_territory', label: 'Licensing Territory', type: 'text', defaultValue: 'India' },
          { name: 'license_fee', label: 'License Fee', type: 'text' },
          { name: 'target_customers', label: 'Target Customers', type: 'text' },
          { name: 'royalty', label: 'Royalty', type: 'text' },
          
          // Display Settings
          { name: 'is_highlighted', label: 'Highlighted (Homepage)', type: 'checkbox', defaultValue: true, checkboxLabel: 'Show on homepage' },
          { name: 'priority', label: 'Priority', type: 'number', defaultValue: 0, min: 0, max: 100, hint: 'Higher priority = shown first on homepage. 0 = normal listing' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['name', 'category', 'is_highlighted', 'priority', 'is_published']}
      />
    </AdminLayout>
  );
}
